// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.inner-content {
  background-color: #FFF7EC;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.inner-content.full-height {
  height: 100vh;
}

.content-wrapper {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 77px 30px 85px;
  display: flex;
  flex-direction: column;
}
.content-wrapper.page-view {
  padding-top: 26px;
  padding-bottom: 17px;
}
.content-wrapper.page-view-mobile {
  padding: 20px;
}

.not-visible {
  opacity: 0;
  pointer-events: none;
}

.find-answer {
  margin-top: auto;
  text-align: center;
  color: var(--vl-black);
  font-size: 14px;
  font-family: "Roboto-Regular";
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 85px;
}
.find-answer .link {
  font-family: "Roboto-Medium";
  width: 100%;
  text-decoration-line: underline;
}

.help-header__title {
  font-weight: 700;
  font-size: 28px;
  color: #262627;
  margin-bottom: 24px;
  font-family: "Roboto-Medium";
}

.help-content {
  font-size: 16px;
  font-family: "Roboto-Regular";
  color: var(--vl-black-font);
  padding-bottom: 50px;
}

.contact-us-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 10px;
  font-family: "Roboto-Medium";
  display: flex;
  flex-direction: column;
}
.contact-us-wrapper .or {
  padding-bottom: 10px;
  text-transform: uppercase;
}
.contact-us-wrapper .contact-us {
  text-decoration: underline;
}

.back-wrapper {
  display: flex;
  justify-content: flex-end;
  position: fixed;
  background: #FFF7EC;
  top: 0;
  right: 0;
  width: 100%;
  padding: 30px 30px 20px;
  z-index: 3000;
}

.sliders-wrapper {
  display: flex;
  align-items: center;
  padding: 10px 30px 1.3rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #FFF7EC;
  z-index: 3000;
}
.sliders-wrapper.not-fixed {
  position: unset;
  justify-content: space-evenly;
  align-items: center;
}
.sliders-wrapper.not-fixed ion-button {
  flex: 0.1;
}
.sliders-wrapper.not-fixed ion-button:last-child {
  margin-top: 7px;
}
.sliders-wrapper .element {
  flex: 1;
  display: flex;
  justify-content: center;
}
.sliders-wrapper .element:first-child {
  text-align: left;
}
.sliders-wrapper .element:last-child {
  text-align: right;
}
.sliders-wrapper vl-icon {
  stroke: transparent;
  color: var(--vl-black-font);
}
.sliders-wrapper ion-button {
  width: 100%;
  text-align: center;
  white-space: nowrap;
  --padding-start: 0;
  --padding-end: 0;
  --background: none;
  --background-hover: none;
  --background-activated: none;
  --ripple-color: transparent;
  color: var(--vl-black-font);
  width: fit-content;
  font-size: 15px;
  font-family: "Roboto-Regular";
}
.sliders-wrapper ion-button .left {
  padding-left: 5px;
}
.sliders-wrapper ion-button .right {
  padding-right: 5px;
}
.sliders-wrapper ion-button ion-icon {
  --ionicon-stroke-width: 16px;
}
.sliders-wrapper ion-button:first-child {
  margin-left: -5px;
}
.sliders-wrapper ion-button:last-child {
  margin-right: -5px;
}

@media (max-width: 576px) {
  .inner-content .find-answer {
    margin-bottom: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/shared/components/context-help/context-help-details/context-help-details.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AA0DF;AAzDE;EACE,aAAA;AA2DJ;;AAvDA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AA0DF;AAxDE;EACE,iBAAA;EACA,oBAAA;AA0DJ;AAvDE;EACE,aAAA;AAyDJ;;AArDA;EACI,UAAA;EACA,oBAAA;AAwDJ;;AArDA;EACI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,6BD/Ba;ECgCb,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAwDJ;AAvDI;EACI,4BDxCQ;ECyCR,WAAA;EACA,+BAAA;AAyDR;;AArDA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,4BDnDY;AC2GhB;;AArDA;EACI,eAAA;EACA,6BDtDa;ECuDb,2BAAA;EACA,oBAAA;AAwDJ;;AArDA;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,4BDjEY;ECkEZ,aAAA;EACA,sBAAA;AAwDJ;AAvDI;EACI,oBAAA;EACA,yBAAA;AAyDR;AAvDI;EACI,0BAAA;AAyDR;;AArDA;EACI,aAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;AAwDJ;;AArDA;EAYI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;AA6CJ;AA/DI;EACI,eAAA;EACA,6BAAA;EACA,mBAAA;AAiER;AAhEQ;EACI,SAAA;AAkEZ;AAjEY;EACI,eAAA;AAmEhB;AAvDI;EACI,OAAA;EACA,aAAA;EACA,uBAAA;AAyDR;AAtDG;EACC,gBAAA;AAwDJ;AArDE;EACE,iBAAA;AAuDJ;AArDI;EACI,mBAAA;EACA,2BAAA;AAuDR;AArDI;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,6BDzIS;ACgMjB;AAtDQ;EACI,iBAAA;AAwDZ;AAtDQ;EACI,kBAAA;AAwDZ;AAtDQ;EACI,4BAAA;AAwDZ;AAtDQ;EACI,iBAAA;AAwDZ;AAtDQ;EACI,kBAAA;AAwDZ;;AAnDA;EAEQ;IACI,2BAAA;EAqDV;AACF","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n.inner-content {\n  background-color: #FFF7EC;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  &.full-height {\n    height: 100vh;\n  }\n}\n\n.content-wrapper {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 77px 30px 85px;\n  display: flex;\n  flex-direction: column;\n\n  &.page-view {\n    padding-top: 26px;\n    padding-bottom: 17px;\n  }\n\n  &.page-view-mobile {\n    padding: 20px;\n  }\n}\n\n.not-visible {\n    opacity: 0;\n    pointer-events: none;\n}\n\n.find-answer {\n    margin-top: auto;\n    text-align: center;\n    color: var(--vl-black);\n    font-size: 14px;\n    font-family: $roboto-regular;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 85px;\n    .link {\n        font-family: $roboto-medium;\n        width: 100%;\n        text-decoration-line: underline;\n    }\n}\n\n.help-header__title {\n    font-weight: 700;\n    font-size: 28px;\n    color: #262627;\n    margin-bottom: 24px;\n    font-family: $roboto-medium;\n}\n\n.help-content {\n    font-size: 16px;\n    font-family: $roboto-regular;\n    color: var(--vl-black-font);\n    padding-bottom: 50px;\n}\n\n.contact-us-wrapper {\n    display: flex;\n    justify-content: center;\n    padding-top: 10px;\n    font-family: $roboto-medium;\n    display: flex;\n    flex-direction: column;\n    .or {\n        padding-bottom: 10px;\n        text-transform: uppercase;\n    }\n    .contact-us {\n        text-decoration: underline;\n    }\n}\n\n.back-wrapper {\n    display: flex;\n    justify-content: flex-end;\n    position: fixed;\n    background: #FFF7EC;\n    top: 0;\n    right: 0;\n    width: 100%;\n    padding: 30px 30px 20px;\n    z-index: 3000;\n}\n\n.sliders-wrapper {\n    &.not-fixed {\n        position: unset;\n        justify-content: space-evenly;\n        align-items: center;\n        ion-button {\n            flex: 0.1;\n            &:last-child {\n                margin-top: 7px;\n            }\n        }\n    }\n    display: flex;\n    align-items: center;\n    padding: 10px 30px 1.3rem;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    background-color: #FFF7EC;\n    z-index: 3000;\n    .element {\n        flex: 1;\n        display: flex;\n        justify-content: center;\n    }\n      \n   .element:first-child {\n    text-align: left;\n  }\n\n  .element:last-child {\n    text-align: right;\n  }\n    vl-icon {\n        stroke: transparent;\n        color: var(--vl-black-font);\n    }\n    ion-button {\n        width: 100%;\n        text-align: center;\n        white-space: nowrap;\n        --padding-start: 0;\n        --padding-end: 0;\n        --background: none;\n        --background-hover: none;\n        --background-activated: none;\n        --ripple-color: transparent;\n        color: var(--vl-black-font);\n        width: fit-content;\n        font-size: 15px;\n        font-family: $roboto-regular;\n        .left {\n            padding-left: 5px;\n        }\n        .right {\n            padding-right: 5px;\n        }\n        ion-icon {\n            --ionicon-stroke-width: 16px;\n        }\n        &:first-child {\n            margin-left: -5px;\n        }\n        &:last-child {\n            margin-right: -5px;\n        }\n    }\n}\n\n@media (max-width: 576px) {\n    .inner-content {\n        .find-answer {\n            margin-bottom: 0 !important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
